import { useParams } from "react-router-dom";
import useDatasetPrefixes from "datasets/hooks/useDatasetPrefixes";
import FileTitle from "files/components/FileTitle";
import { encodeObjectKey, resolveObjectKey, resolveRouterPath } from "files/hooks/useFiles";
import { BooleanParam, useQueryParam } from "use-query-params";
import useUser from "~/contexts/user";

const useDatasetFileBreadcrumbs = () => {
  const user = useUser();
  const { datasetId } = useParams();
  const basePath = `/data-browser/datasets/${datasetId}/files`;
  const { data: prefixes } = useDatasetPrefixes();
  const { prefixId, "*": filePath = "" } = useParams();
  const [preview] = useQueryParam("preview", BooleanParam);
  const selectedPrefix = resolveRouterPath(
    prefixes?.find(({ id }) => id === prefixId)?.prefix ?? ""
  );
  const stripPath = selectedPrefix.replace(/[^/]+$/, "");
  const crumbPath = filePath.replace(stripPath, "");
  const breadcrumbs = crumbPath
    .split("/")
    .filter(String)
    .slice(0, preview ? -1 : undefined);

  const rootCrumb = { title: "Files", prefix: "", href: basePath };

  if (prefixes) {
    const prefixPath = `${basePath}/${prefixId}`;
    return [
      rootCrumb,
      ...breadcrumbs.map((_, index) => {
        const filePath = [selectedPrefix, ...breadcrumbs.slice(1, index + 1)].join("/");
        const currentKey = resolveObjectKey(filePath, user?.email);
        const routerPath = encodeObjectKey([prefixPath, resolveRouterPath(currentKey)].join("/"));
        return { title: <FileTitle fileKey={currentKey} />, prefix: currentKey, href: routerPath };
      }),
    ];
  }

  // Prefixes loading, just show "Files" for now
  return [rootCrumb];
};

export default useDatasetFileBreadcrumbs;
